<br />
<div class="row margin-left-20">
    <h2>See Also:</h2>
</div>
<div *ngFor="let aLink of concepts; let i=index" class="row margin-left-40">
    <!-- TODO Add ability for a timeindex -->
    <a *ngIf="aLink.conceptLinkType == 2 && i < displayAmount" [routerLink]='["/blogentryview", aLink.Alias]'>
        <h5 style="color: #337ab7; font-size: 12pt">Blog: {{aLink.Name}}</h5>
    </a>
    <a *ngIf="aLink.conceptLinkType == 1 && i < displayAmount" [routerLink]='["/coursewarecontentview", aLink.Alias]'>
        <h5 style="color: #337ab7; font-size: 12pt">Foundations of Law: {{aLink.Name}}</h5>
    </a>
    <a *ngIf="aLink.conceptLinkType == 3 && i < displayAmount" [routerLink]='["/shortvideoscontentview", aLink.Alias]' [queryParams]="{ TimeIndex: aLink.TimeIndex}">
        <h5 style="color: #337ab7; font-size: 12pt">Short Video: {{aLink.Name}}  </h5>
    </a>
    <!-- TODO Add ability for a timeindex -->
    <a *ngIf="aLink.conceptLinkType == 0 && i < displayAmount" [routerLink]='["/videocoursesmoduleview", aLink.Alias]'>
        <h5 style="color: #337ab7; font-size: 12pt">Video-Course: {{aLink.Name}}  </h5>
    </a>
</div>
<br />